export default __webpack_public_path__ + "static/media/Hangman6.0b8819f8.svg";